import Vuex from "vuex";
import Vue from "vue";
import storage from "./storage";

const state = {
  pages: [],
  selectedTabName: "",
  user: null,
  sessionId: "",
  isLogin: false,
  windowResize: 0,
  notChina: false
};

const getters = {
  pages(state) {
    return state.pages;
  },
  selectedTabName(state) {
    return state.selectedTabName;
  },
  currentPage(state) {
    let page = state.pages.find(page => page.name === state.selectedTabName);
    return page;
  },
  // 防止切换用户造成的缓存
  user: state => () => {
    return storage.getO("user");
  },
  sessionId(state) {
    return storage.get("sessionId");
  },
  isLogin(state) {
    return storage.getO("isLogin");
  },
  roles(state) {
    return storage.getO("roles");
  },
  notChina(state) {
    return storage.getO("notChina");
  },
  // 窗口变化
  windowResize(state) {
    return state.windowResize;
  }
};

const mutations = {
  selectPage(state, page) {
    state.selectedTabName = page;
  },
  addHome(state, home) {
    let activedPages = state.pages.filter(page => page.actived);

    for (let ap of activedPages) {
      if (ap.name === home.name) {
        //说明当前tab是首页，无需操作
        return;
      }
    }

    let page = state.pages.find(page => page.name === home.name);
    if (!page) {
      state.pages = [home].concat(state.pages);
    }
  },
  addPage(state, data) {
    let page = state.pages.find(page => page.name === data.name);
    if (!page) {
      page = data;
      state.pages.push(data);
    }
    page.actived = true;
    state.pages
      .filter(page => page.actived && page.name !== data.name)
      .forEach(page => {
        page.actived = false;
      });
    state.selectedTabName = page.name;
  },
  removePage(state, name) {
    let index = state.pages.findIndex(page => page.name === name);
    if (index >= 0) {
      state.pages.splice(index, 1);
    }
  },
  clearPage(state) {
    state.pages = [];
  },
  logout(state) {
    storage.clear();
    state.selectedTabName = "";
    state.pages = [];
  },
  windowSizeChange() {
    state.windowResize++;
  }
};

Vue.use(Vuex);
export default new Vuex.Store({
  state,
  getters,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js